import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import pt from 'prop-types';
import { Element, BreakpointContext, BoxHelper } from '../';
import { appendHtmlClass, extendProps, borderPropType, responsivePropType } from '../../js/util';
import getConfig from '../../js/settings';
import './_index.scss';
var BORDER_DEFAULT = getConfig('BOX_BORDER_DEFAULT');
var Ruler = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Ruler, _React$Component);
  function Ruler() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.ALLOWED_PROPS = ['className', 'id', 'style', 'border', 'width', 'margin', 'marginTop', 'marginBottom', 'marginLeft', 'marginRight'];
    return _this;
  }
  var _proto = Ruler.prototype;
  _proto.getStyle = function getStyle() {
    var style = typeof this.props.style == 'object' ? this.props.style : {};
    return Object.assign({}, style, BoxHelper.getSpacingStyle(this.context, this.props, 'margin'), BoxHelper.getDimensionStyle(this.context, this.props, 'width'));
  };
  _proto.getClass = function getClass() {
    var className = this.props.className;
    className = appendHtmlClass(className, BoxHelper.getBorderClass(this.context, {
      borderBottom: this.props.border
    }));
    return className;
  };
  _proto.render = function render() {
    var _this2 = this;
    var id = this.props.id;
    var otherProps = {};
    Object.keys(this.props).filter(function (prop) {
      return _this2.ALLOWED_PROPS.indexOf(prop) < 0;
    }).forEach(function (prop) {
      otherProps[prop] = _this2.props[prop];
    });
    return /*#__PURE__*/React.createElement(Element, Object.assign({
      as: "hr",
      className: this.getClass(),
      id: id,
      style: this.getStyle()
    }, otherProps));
  };
  return Ruler;
}(React.Component);
Ruler.contextType = BreakpointContext;
var boxProps = {
  margin: responsivePropType.bind(this, pt.oneOfType([pt.number, pt.arrayOf(pt.number)])),
  marginTop: responsivePropType.bind(this, pt.number),
  marginBottom: responsivePropType.bind(this, pt.number),
  marginLeft: responsivePropType.bind(this, pt.number),
  marginRight: responsivePropType.bind(this, pt.number),
  width: responsivePropType.bind(this, pt.oneOfType([pt.number, pt.string])),
  border: responsivePropType.bind(this, borderPropType)
};
Object.assign(Ruler, extendProps(Element, ['className', 'id', 'children', 'style', 'isAnimated'], boxProps, {
  border: BORDER_DEFAULT
}));
export default Ruler;